// extracted by mini-css-extract-plugin
export default {"itemsList":"filterList_itemsList__xAi1E","item":"filterList_item__DuoYh","currentItem":"filterList_currentItem__9ET4B"};